import filter from "lodash/filter";
import get from "lodash/get";
import includes from "lodash/includes";
import map from "lodash/map";
import omit from "lodash/omit";
import set from "lodash/set";
export function getIsSelected(treeNode, selectedKey, keyExpr, itemsExpr) {
    if (!get(treeNode, itemsExpr))
        return includes(selectedKey, get(treeNode, keyExpr));
    const selectedChildren = filter(get(treeNode, itemsExpr), e => getIsSelected(e, selectedKey, keyExpr, itemsExpr));
    if (selectedChildren.length === 0)
        return false;
    if (selectedChildren.length === get(treeNode, itemsExpr).length)
        return true;
    return undefined;
}
export function buildTreeNodes(treeNodes, selectedKey, expandedItems, keyExpr = "id", itemsExpr = "items") {
    return map(treeNodes, node => {
        const res = {
            ...omit(node, "selected"),
            selected: getIsSelected(node, selectedKey, keyExpr, itemsExpr)
        };
        if (get(node, itemsExpr)) {
            res.expanded = includes(expandedItems, get(node, keyExpr));
            set(res, itemsExpr, buildTreeNodes(get(node, itemsExpr), selectedKey, expandedItems, keyExpr, itemsExpr));
        }
        return res;
    });
}
